/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  getDropdown,
  getMetadata,
  saveDropdown,
  saveMetadata,
} from "../db/indexedDB";

// === Uncomment to enable static demo dropdowns for testing ===
// export const demoDropdowns = {
//   DISEASE_STATUS: {
//     TYPE: "Dropdown",
//     MESSAGE: "Disease Status",
//     ENUM: [
//       { TEXT: "Suspect", CODE: "Suspect", SUBGROUP: "YES_NO_UNKNOWN,DISEASE_STATUS" },
//       { TEXT: "Confirmed", CODE: "Confirmed", SUBGROUP: "DISEASE_STATUS" },
//       { TEXT: "Probable", CODE: "Probable", SUBGROUP: "DISEASE_STATUS" },
//       { TEXT: "Not a case", CODE: "Not a case", SUBGROUP: "DISEASE_STATUS" },
//       { TEXT: "Unknown", CODE: "Unknown", SUBGROUP: "YES_NO_UNKNOWN,DISEASE_STATUS" },
//     ],
//     VALUE: "Unknown",
//     EDITABLE: true,
//     REFERENCE: {
//       TIMESTAMP: 1751385494,
//       CODE: "DISEASE_STATUS",
//       SUBGROUP: "YES_NO_UNKNOWN",
//     },
//   },
// };

// Utility to filter ENUMs by subgroup if provided
const filterBySubgroup = (enumList, subgroupCode) => {
  if (!subgroupCode) return enumList;
  return enumList.filter(
    (item) => !item.SUBGROUP || item.SUBGROUP.split(",").includes(subgroupCode),
  );
};

export const useLazyDropdown = (code, timestamp, subgroup) => {
  const [options, setOptions] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (isLoaded) return;
    setLoading(true);

    try {
      // === Demo mode: use static data instead of API ===
      // Uncomment below to test with demoDropdowns data:
      /*
      const demo = demoDropdowns[code];
      if (demo) {
        const filtered = filterBySubgroup(demo.ENUM, subgroup);
        const formatted = filtered.map((item) => ({
          label: item.TEXT,
          value: item.CODE,
        }));

        await saveDropdown(code, subgroup, formatted);
        await saveMetadata(code, subgroup, demo.REFERENCE.TIMESTAMP);

        setOptions(formatted);
        setIsLoaded(true);
        setLoading(false);
        return;
      }
      */

      // === Normal mode: load from IndexedDB or API ===
      const lastUpdate = await getMetadata(code, subgroup);
      const shouldUpdate =
        lastUpdate === undefined ||
        lastUpdate === null ||
        (timestamp && Number(lastUpdate) < Number(timestamp));

      if (shouldUpdate) {
        const res = await fetch(`/api/getCodes?id=${code}`);
        const json = await res.json();

        // Extract options array safely
        const enumList = Array.isArray(json.CONFIG) ? json.CONFIG : [];

        const filtered = subgroup
          ? filterBySubgroup(enumList, subgroup)
          : enumList;

        const formatted = filtered.map((item) => ({
          label: item.TEXT,
          value: item.CODE,
        }));

        await saveDropdown(code, subgroup, formatted);

        await saveMetadata(code, subgroup, timestamp ? Number(timestamp) : -1);

        setOptions(formatted);
      } else {
        const cached = await getDropdown(code, subgroup);
        setOptions(cached || []);
      }

      setIsLoaded(true);
    } catch (err) {
      console.error(`❌ Failed to load dropdown for ${code}`, err);
      const fallback = await getDropdown(code, subgroup);
      setOptions(fallback || []);
    }

    setLoading(false);
  };

  // 🆕 Automatically preload options on mount
  useEffect(() => {
    if (!code) return;
    load();
  }, [code]);

  return { options, load, loading };
};
